import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { RotatedSortIcon } from "../../../shared/components/TableFilter";
import { ProductLocationsData } from "../../../../interfaces/product";

const VerifyLocationTable = ({
  data,
  handeSortChange,
  handleOrderTypeChange,
  order,
  orderType,
}: {
  data: ProductLocationsData[];
  handeSortChange: (state: "ASC" | "DESC") => void;
  handleOrderTypeChange: (type: string) => void;
  order: "ASC" | "DESC";
  orderType: string;
}) => {
  return (
    <>
      <TableContainer component={Paper}>
        <Table
          sx={{
            table: {
              minWidth: 650,
            },
          }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                onClick={() => {
                  handeSortChange(order === "ASC" ? "DESC" : "ASC");
                  handleOrderTypeChange("productCode");
                }}
              >
                Articolo
                {orderType === "productCode" && (
                  <IconButton>
                    <RotatedSortIcon rotation={order === "DESC" ? 0 : 180} />
                  </IconButton>
                )}
              </TableCell>
              <TableCell
                align="right"
                onClick={() => {
                  handeSortChange(order === "ASC" ? "DESC" : "ASC");
                  handleOrderTypeChange("quantity");
                }}
              >
                Matricola
              </TableCell>
              <TableCell
                align="right"
                onClick={() => {
                  handeSortChange(order === "ASC" ? "DESC" : "ASC");
                  handleOrderTypeChange("quantity");
                }}
              >
                Ubicazione
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row: ProductLocationsData) => (
              <TableRow key={row.productCode}>
                <TableCell component="th" scope="row">
                  {row.productCode}
                </TableCell>
                <TableCell align="right">{row.serialNumber}</TableCell>
                <TableCell align="right">{row.warehouseLocation}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default VerifyLocationTable;
